// Shared React Query key for the Sites admin list (AdminSites.tsx). Exported so other
// components (e.g. SiteStatusModal) can invalidate the list after mutating a site.
export const SITES_QUERY_KEY = "sites-admin";

// A site's sync records ([key, siteId, ...]): the Sync Records tab and the sync watcher, which
// refreshes them when a queued sync finishes.
export const SITE_SYNC_RECORDS_QUERY_KEY = "site-sync-records";
